/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddLocationToProjectCommandResult } from '../models/add-location-to-project-command-result';
import { apiProjectLocationsAddLocationToProjectPost } from '../fn/project-locations/api-project-locations-add-location-to-project-post';
import { ApiProjectLocationsAddLocationToProjectPost$Params } from '../fn/project-locations/api-project-locations-add-location-to-project-post';
import { apiProjectLocationsAddLocationToProjectPost$Plain } from '../fn/project-locations/api-project-locations-add-location-to-project-post-plain';
import { ApiProjectLocationsAddLocationToProjectPost$Plain$Params } from '../fn/project-locations/api-project-locations-add-location-to-project-post-plain';
import { apiProjectLocationsGetProjectLocationsGet } from '../fn/project-locations/api-project-locations-get-project-locations-get';
import { ApiProjectLocationsGetProjectLocationsGet$Params } from '../fn/project-locations/api-project-locations-get-project-locations-get';
import { apiProjectLocationsGetProjectLocationsGet$Plain } from '../fn/project-locations/api-project-locations-get-project-locations-get-plain';
import { ApiProjectLocationsGetProjectLocationsGet$Plain$Params } from '../fn/project-locations/api-project-locations-get-project-locations-get-plain';
import { apiProjectLocationsRemoveLocationFromProjectDelete } from '../fn/project-locations/api-project-locations-remove-location-from-project-delete';
import { ApiProjectLocationsRemoveLocationFromProjectDelete$Params } from '../fn/project-locations/api-project-locations-remove-location-from-project-delete';
import { apiProjectLocationsRemoveLocationFromProjectDelete$Plain } from '../fn/project-locations/api-project-locations-remove-location-from-project-delete-plain';
import { ApiProjectLocationsRemoveLocationFromProjectDelete$Plain$Params } from '../fn/project-locations/api-project-locations-remove-location-from-project-delete-plain';
import { GetProjectLocationsQueryResult } from '../models/get-project-locations-query-result';
import { RemoveLocationFromProjectCommandResult } from '../models/remove-location-from-project-command-result';

@Injectable({ providedIn: 'root' })
export class ProjectLocationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiProjectLocationsAddLocationToProjectPost()` */
  static readonly ApiProjectLocationsAddLocationToProjectPostPath = '/api/ProjectLocations/AddLocationToProject';

  /**
   * Add a location to a specific project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectLocationsAddLocationToProjectPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectLocationsAddLocationToProjectPost$Plain$Response(params?: ApiProjectLocationsAddLocationToProjectPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddLocationToProjectCommandResult>> {
    return apiProjectLocationsAddLocationToProjectPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a location to a specific project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectLocationsAddLocationToProjectPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectLocationsAddLocationToProjectPost$Plain(params?: ApiProjectLocationsAddLocationToProjectPost$Plain$Params, context?: HttpContext): Observable<AddLocationToProjectCommandResult> {
    return this.apiProjectLocationsAddLocationToProjectPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddLocationToProjectCommandResult>): AddLocationToProjectCommandResult => r.body)
    );
  }

  /**
   * Add a location to a specific project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectLocationsAddLocationToProjectPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectLocationsAddLocationToProjectPost$Response(params?: ApiProjectLocationsAddLocationToProjectPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddLocationToProjectCommandResult>> {
    return apiProjectLocationsAddLocationToProjectPost(this.http, this.rootUrl, params, context);
  }

  /**
   * Add a location to a specific project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectLocationsAddLocationToProjectPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectLocationsAddLocationToProjectPost(params?: ApiProjectLocationsAddLocationToProjectPost$Params, context?: HttpContext): Observable<AddLocationToProjectCommandResult> {
    return this.apiProjectLocationsAddLocationToProjectPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddLocationToProjectCommandResult>): AddLocationToProjectCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectLocationsRemoveLocationFromProjectDelete()` */
  static readonly ApiProjectLocationsRemoveLocationFromProjectDeletePath = '/api/ProjectLocations/RemoveLocationFromProject';

  /**
   * Remove a location from a specific project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectLocationsRemoveLocationFromProjectDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectLocationsRemoveLocationFromProjectDelete$Plain$Response(params?: ApiProjectLocationsRemoveLocationFromProjectDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoveLocationFromProjectCommandResult>> {
    return apiProjectLocationsRemoveLocationFromProjectDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove a location from a specific project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectLocationsRemoveLocationFromProjectDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectLocationsRemoveLocationFromProjectDelete$Plain(params?: ApiProjectLocationsRemoveLocationFromProjectDelete$Plain$Params, context?: HttpContext): Observable<RemoveLocationFromProjectCommandResult> {
    return this.apiProjectLocationsRemoveLocationFromProjectDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RemoveLocationFromProjectCommandResult>): RemoveLocationFromProjectCommandResult => r.body)
    );
  }

  /**
   * Remove a location from a specific project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectLocationsRemoveLocationFromProjectDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectLocationsRemoveLocationFromProjectDelete$Response(params?: ApiProjectLocationsRemoveLocationFromProjectDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<RemoveLocationFromProjectCommandResult>> {
    return apiProjectLocationsRemoveLocationFromProjectDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Remove a location from a specific project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectLocationsRemoveLocationFromProjectDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiProjectLocationsRemoveLocationFromProjectDelete(params?: ApiProjectLocationsRemoveLocationFromProjectDelete$Params, context?: HttpContext): Observable<RemoveLocationFromProjectCommandResult> {
    return this.apiProjectLocationsRemoveLocationFromProjectDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<RemoveLocationFromProjectCommandResult>): RemoveLocationFromProjectCommandResult => r.body)
    );
  }

  /** Path part for operation `apiProjectLocationsGetProjectLocationsGet()` */
  static readonly ApiProjectLocationsGetProjectLocationsGetPath = '/api/ProjectLocations/GetProjectLocations';

  /**
   * Get all locations associated with a specific project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectLocationsGetProjectLocationsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectLocationsGetProjectLocationsGet$Plain$Response(params?: ApiProjectLocationsGetProjectLocationsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectLocationsQueryResult>> {
    return apiProjectLocationsGetProjectLocationsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all locations associated with a specific project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectLocationsGetProjectLocationsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectLocationsGetProjectLocationsGet$Plain(params?: ApiProjectLocationsGetProjectLocationsGet$Plain$Params, context?: HttpContext): Observable<GetProjectLocationsQueryResult> {
    return this.apiProjectLocationsGetProjectLocationsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectLocationsQueryResult>): GetProjectLocationsQueryResult => r.body)
    );
  }

  /**
   * Get all locations associated with a specific project.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiProjectLocationsGetProjectLocationsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectLocationsGetProjectLocationsGet$Response(params?: ApiProjectLocationsGetProjectLocationsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectLocationsQueryResult>> {
    return apiProjectLocationsGetProjectLocationsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all locations associated with a specific project.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiProjectLocationsGetProjectLocationsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiProjectLocationsGetProjectLocationsGet(params?: ApiProjectLocationsGetProjectLocationsGet$Params, context?: HttpContext): Observable<GetProjectLocationsQueryResult> {
    return this.apiProjectLocationsGetProjectLocationsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetProjectLocationsQueryResult>): GetProjectLocationsQueryResult => r.body)
    );
  }

}
